import { CountryKeyValue, Locale } from '@headless-workspace/config';
import { ConfigByKeyRepository, Result, ResultEmpty, ResultSuccess } from '@headless-workspace/core-domain';
import { LanguageHelpers } from '@headless-workspace/utils';
import { LoyaltyConfigDTO } from './LoyaltyConfigDTO';
import { BaseLoyaltyConfig, LoyaltyConfigsValue, mapLoyaltyConfigsValue } from './LoyaltyConfigsValue';
import { LoyaltyPointsPerCurrencyDTO } from './LoyaltyPointsPerCurrencyDTO';

export const LOYALTY_CONFIGS_KEY = 'loyaltyConfigs';
const LOYALTY_PER_CURRENCY_KEY = 'loyaltyPointsPerCurrency';

export interface LoyaltyConfigsRepositorySpec {
    fetchLoyaltyConfiguration(locale: Locale): Promise<Result<LoyaltyConfigsValue>>;
}

export class LoyaltyConfigsRepository extends ConfigByKeyRepository implements LoyaltyConfigsRepositorySpec {
    async fetchLoyaltyConfiguration(locale: Locale): Promise<Result<LoyaltyConfigsValue>> {
        const [loyaltyConfigsResult, loyaltyPointsPerCurrency] = await Promise.all([
            this.getConfigByKey(LOYALTY_CONFIGS_KEY, { locale }, (value) =>
                LoyaltyConfigDTO.parse(
                    LanguageHelpers.retrieveDataByCountry(value as CountryKeyValue<BaseLoyaltyConfig>, locale),
                ),
            ),
            this.getConfigByKey(LOYALTY_PER_CURRENCY_KEY, { locale }, (value) =>
                LoyaltyPointsPerCurrencyDTO.parse(value),
            ),
        ]);

        if (loyaltyConfigsResult.type !== 'success' || loyaltyPointsPerCurrency.type !== 'success') {
            return ResultEmpty();
        }

        return ResultSuccess(mapLoyaltyConfigsValue(loyaltyConfigsResult.data, loyaltyPointsPerCurrency.data));
    }
}
